import React, { Component } from 'react'
import ServiceModal from './ServiceModal'
import { connect } from "react-redux";
import { updateTicket } from "../../actions/ticketAction";
import { addComment, ticketItemData } from "../../actions";
import { URL_API } from "../../constants";
import Icon from '@material-ui/core/Icon'
import { withStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import cs from 'classnames'
import './btnColors.css'

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        color: '#fff',
        fontWeitht: '600'
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
})

class ButtonService extends Component {

    state = {
        open: false,
        value: ''
    }
    handleOpenModal = () => {
        this.setState({ open: true });
    };

    handleCloseModal = () => {
        this.setState({ open: false })
    }


    handleClick = (value) => {
        this.props.onClick(value)
    }

    handleSend = (jData) => {
        const { status, ticket_id } = this.props

        if (jData.comment) {
            let comment = {
                request: ticket_id,
                comment: jData.comment
            }
            this.props.addComment(comment)

        }
        let ticket = {
            status
        }

        if (jData.repair_id) {
            ticket = {
                ...ticket,
                repairs: jData.repair_id
            }

        }
        this.props.updateTicket(ticket_id, ticket)

        setTimeout(() => {
            this.props.fetchData(`${URL_API}/request/${ticket_id}/`);
        }, 100)
    }
    // coordination
    render() {

        const { color, icon, title, disabled, short, deny, comment, classes } = this.props;
        if (deny) {
            return null
        }

        return (
            <div className="step-item">
                <Fab onClick={(!disabled) ? this.handleOpenModal : null}
                    variant="extended" aria-label="Add" className={cs(classes.button, color)}>
                    <Icon className={classes.leftIcon}>{icon}</Icon><span>{title}</span>
                </Fab>
                <ServiceModal
                    value={this.state.value}
                    open={this.state.open}
                    repair_list={this.props.list}
                    onClose={this.handleCloseModal}
                    repair={(short === "coordination") ? true : false}
                    submit={this.handleSend}
                    short={short}
                    comment={comment}
                />
            </div >


        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};
const mapPropsToDispath = (dispatch) => {
    return {
        updateTicket: (id, jData) => dispatch(updateTicket(id, jData)),
        addComment: (jData) => dispatch(addComment(jData)),
        fetchData: (url) => dispatch(ticketItemData(url)),
    }
}

export default connect(mapStateToProps, mapPropsToDispath)(withStyles(styles)(ButtonService))


// WEBPACK FOOTER //
// ./src/components/Service/ButtonService.js